import React from "react";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  ContentContainer,
  ModalTitle,
  ModalText,
  ButtonsContainer,
  DiscardButton,
} from "./UnsavedChangesModal.styled";

interface UnsavedChangesModalProps {
  onDiscard: () => void;
  onBack: () => void;
}

const UnsavedChangesModalContent: React.FC<UnsavedChangesModalProps> = ({
  onDiscard,
  onBack,
}) => {
  const { t } = useTranslation();

  return (
    <ContentContainer>
      <ModalTitle>
        {t("unsavedChanges.title", "Unsaved Changes")}
      </ModalTitle>

      <ModalText>
        {t(
          "unsavedChanges.message1",
          "You have unsaved updates on this page."
        )}
        <br />
        {t(
          "unsavedChanges.message2",
          "If you exit now, your changes will be lost."
        )}
        <br />
        {t(
          "unsavedChanges.message3",
          "Would you like to save before closing?"
        )}
      </ModalText>

      <ButtonsContainer>
        <DiscardButton variant="contained" onClick={onDiscard}>
          {t("unsavedChanges.discardButton", "Discard Changes")}
        </DiscardButton>
        <Button variant="outlined" onClick={onBack}>
          {t("unsavedChanges.backButton", "Back to Editing")}
        </Button>
      </ButtonsContainer>
    </ContentContainer>
  );
};

export default UnsavedChangesModalContent;

